import React from 'react';
import * as MuiCore from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

const KnowledgeBaseCard = ({ 
    knowledgeBase, 
    editing, 
    tempValue,
    onEdit, 
    onSave, 
    onCancel, 
    onChange,
    error,
    classes 
}) => {
    return (
        <MuiCore.Box className={classes.section}>
            <MuiCore.Box className={classes.sectionHeader}>
                <MuiCore.Box className={classes.sectionTitle}>
                    <MuiCore.SvgIcon>
                        <path d="M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"/>
                    </MuiCore.SvgIcon>
                    <MuiCore.Typography variant="h6" style={{ fontFamily: 'Sofia-bold' }}>Knowledge Base</MuiCore.Typography>
                </MuiCore.Box>
                {!editing && (
                    <MuiCore.Button
                        startIcon={<EditIcon />}
                        className={classes.editButton}
                        variant="outlined"
                        onClick={onEdit}
                    >
                        EDIT
                    </MuiCore.Button>
                )}
            </MuiCore.Box>
            <MuiCore.Typography variant="body2" color="textSecondary" style={{ marginBottom: 16, fontFamily: 'Sofia' }}>
                Your Grasshopper AI will use the information provided to interact with your callers
            </MuiCore.Typography>
            {editing ? (
                <>
                    <MuiCore.TextField
                        label="Knowledge Base"
                        multiline
                        rows={10}
                        value={tempValue}
                        onChange={(e) => onChange(e.target.value)}
                        className={classes.textField}
                        variant="outlined"
                        placeholder="Please enter any information you'd like your Grasshopper AI to know when talking to the callers."
                        inputProps={{ maxLength: 60000, style: { fontFamily: 'Sofia' } }}
                        InputLabelProps={{ style: { fontFamily: 'Sofia' } }}
                        InputProps={{ style: { fontFamily: 'Sofia' } }}
                        error={!!error}
                        helperText={error || ''}
                    />
                    <MuiCore.Typography 
                        variant="caption" 
                        style={{ 
                            display: 'block', 
                            textAlign: 'right', 
                            marginTop: 4, 
                            color: tempValue.length > 60000 ? '#d32f2f' : '#666',
                            fontFamily: 'Sofia'
                        }}
                    >
                        {tempValue.length}/60000 Characters
                    </MuiCore.Typography>
                    <MuiCore.Box className={classes.actionButtons}>
                        <MuiCore.Button
                            startIcon={<CloseIcon />}
                            onClick={onCancel}
                            variant="outlined"
                            style={{ fontFamily: 'Sofia', textTransform: 'none', borderRadius: 100 }}
                        >
                            Cancel
                        </MuiCore.Button>
                        <MuiCore.Button
                            startIcon={<CheckIcon />}
                            onClick={onSave}
                            variant="contained"
                            style={{ backgroundColor: '#7F2062', color: '#fff', fontFamily: 'Sofia', fontWeight: 700, textTransform: 'none', borderRadius: 100 }}
                        >
                            Save
                        </MuiCore.Button>
                    </MuiCore.Box>
                </>
            ) : (
                <MuiCore.Typography style={{ 
                    fontFamily: 'Sofia', 
                    whiteSpace: 'pre-line',
                    maxHeight: '120px',
                    overflowY: 'auto',
                    padding: '8px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '4px',
                    backgroundColor: '#fafafa'
                }}>
                    {knowledgeBase || 'No Information'}
                </MuiCore.Typography>
            )}
        </MuiCore.Box>
    );
};

export default KnowledgeBaseCard;
